const commonColumnAttributes = {
  flex: 1,
  align: "center",
  headerAlign: "center",
};

export { commonColumnAttributes };
